import React from 'react'
import OfferTotals from './OfferTotals'
import {IoIosEye, IoIosEyeOff, IoMdCart } from 'react-icons/io';
import { useStateContext } from '../../context/StateContext';
import VisDiv from '../frontend_components/VisDiv';
import { referenceDoc } from '../gestioneDatabase/Docs';
import { allArrayDataInTargetArray, mergeArraysById, unique, registerIdsFromOfferFields } from '../../lib/utils';

const SiteHeader = ({data, hideShowSite = () => {}}) => {
  //#offerTotals
 const {clientOrder, offerTotals, generatedOfferData, siteOffer } = data  
 const {label} = data?.site

const allProducts =  !siteOffer?.offerFields ? [] : siteOffer?.offerFields
const allProductsHidden = allProducts?.every?.((x)=>x?.hide)

const orderWorkedData = !Array.isArray(allProducts) ? [] : allProducts?.filter?.((x)=>{
  return x?.clientOrder?._ref == clientOrder?._id || !x?.clientOrder
})
const areAllInThisOrder = orderWorkedData?.every?.((x)=>x?.clientOrder)

/* const registerIdsFromOfferFields = (offerFields = []) => {
  if(!Array.isArray(offerFields)) return []
  const uniqueRegisters = !Array.isArray(offerFields) ? [] : unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
  const isThereSigns = offerFields?.find?.((x)=>x?.isSign)

  if(isThereSigns) return [...uniqueRegisters, isThereSigns?.registerTemplateId]
  return unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
} */

const siteRegistersIds = registerIdsFromOfferFields(allProducts)
const isSiteHidden =allArrayDataInTargetArray({sourceArray: siteOffer?.hideRegisters , targetArray: siteRegistersIds})

const addToOrder = () => { 
  console.log("ADD TO ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: referenceDoc(clientOrder?._id)}))
  const updatedData = mergeArraysById(allProducts, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowSite(updatedOfferDoc)
}
const removeFromOrder = () => { 
  console.log("REMOVE FROM ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: undefined}))
  const updatedData = mergeArraysById(allProducts, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowSite(updatedOfferDoc)
}
const testFunction = () => {
  console.log("kwsnjcksjndckj", {
    registerIds: siteRegistersIds,
    areAllOffersHidden: isSiteHidden,
    siteOffer,
    hideRegisters: siteOffer?.hideRegisters

  })
}
const showSite = () => {
  //#showHideOffer
  console.log("SHOW Site")
  if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const showSite = {
    ...siteOffer,
    hideRegisters: []
  }
  hideShowSite(showSite)
 }
 const hideSite = () => {
  //#showHideOffer
  console.log("Hide Site")
  const hideSite = {
    ...siteOffer,
    hideRegisters: siteRegistersIds
  }
  hideShowSite(hideSite)
 }

 return (

        <div className='dskh-siteinfo offer-site-header-container'>  
        
          <div className='side' style={{fontSize:"22px"}}>
          <VisDiv rules={[!clientOrder, generatedOfferData?.length>0]} style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}} rules={[isSiteHidden]} onClick={showSite}>
              <IoIosEyeOff fontSize={25} color='white'/>
            </VisDiv>
            <VisDiv className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} rules={[!isSiteHidden]} onClick={hideSite}>
              <IoIosEye fontSize={25} color='white' />
            </VisDiv>
          </VisDiv>
          <VisDiv  rules={[clientOrder]} className='side' style={{alignItems:"center"}}>
          <VisDiv rules={[!areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}}  onClick={(e) => {addToOrder()}}>
              <IoMdCart fontSize={25} color='white'/>
            </VisDiv>
            <VisDiv rules={[areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} onClick={(e) => {removeFromOrder()}}>
              <IoMdCart fontSize={25} color='white' />
            </VisDiv>
          </VisDiv>
          </div>
          <div className='center'>  
            <h3 style={{marginLeft:"30px"}}>{label}</h3>
            <VisDiv rules={[false]}>
              <button type="button" onClick={testFunction}>test site header</button>
            </VisDiv>
          </div>
          <div className='right-side' style={{display:"flex", flexDirection: "column", alignItems:"flex-end", marginRight:"20px"}}>
            <OfferTotals offerTotals={offerTotals}/>
          </div>
        </div> 
  )
}

export default SiteHeader

{/* <div className='offer-site-header-container'>
<h3 style={{marginLeft:"30px"}}>{label}</h3>
<OfferTotals offerTotals={offerTotals}/>
</div> */}